module.exports = __webpack_public_path__ + "img/500.d16b2b06.png";